/**
 * Created by vladislav on 9/6/2022
 */

const IOS = function () {
    Apple.call(this, connector.IOS);

    connector.info.os = connector.OS_IOS;
};

IOS.prototype = Object.create(Apple.prototype);
IOS.prototype.constructor = IOS;

IOS.prototype.isShareSupported = function () {
    return true;
};

IOS.prototype.isShareCheckBoxAvailable = function () {
    return false;
};

IOS.prototype._parsePayload = function (callback) {
    if (this.attributionInitialized) {
        callback(this.attribution);
        return;
    }

    this.callNative("AdjustPlugin.getAttribution", (code, attribution) => {
        this.setAttribution(code === connector.CODE_SUCCEED ? attribution : undefined);
        callback(this.attribution);
    });
};

IOS.prototype.setAttribution = function (attribution) {
    if (attribution) {
        attribution.channel = attribution.channel || attribution.campaign || "";
    }

    this.attribution = attribution;
    this.attributionInitialized = true;
};

IOS.prototype.onNativeEvent = function (event, options) {
    Apple.prototype.onNativeEvent.call(this, event, options);

    switch (event) {
        case "onAttributionChanged":
            this.setAttribution(options.attribution);
            this.bus.trigger("attributionChanged", this.attribution);
            break;
    }
};
